export default __webpack_public_path__ + "static/media/shopping-basket.38b8665a.png";